/**
 * Input Placeholder Module
 * Handles clearing placeholder values on focus and restoring them on blur if empty
 * Also handles Mailchimp form redirect after submission
 */
const InputPlaceholder = {
	init() {
		this.initPlaceholders();
		this.initMailchimpRedirect();
	},

	initPlaceholders() {
		// Target the newsletter form inputs
		const inputs = document.querySelectorAll('#mc_embed_signup input[type="text"], #mc_embed_signup input[type="email"]');
		
		if (!inputs.length) {
			return;
		}

		inputs.forEach(input => {
			// Store the original placeholder value
			const originalPlaceholder = input.value;
			
			// Skip if there's no placeholder value set
			if (!originalPlaceholder) {
				return;
			}

			// Store it as a data attribute
			input.setAttribute('data-placeholder', originalPlaceholder);

			// Clear on focus
			input.addEventListener('focus', function() {
				if (this.value === this.getAttribute('data-placeholder')) {
					this.value = '';
				}
			});

			// Restore on blur if empty
			input.addEventListener('blur', function() {
				if (this.value.trim() === '') {
					this.value = this.getAttribute('data-placeholder');
				}
			});
		});
	},

	initMailchimpRedirect() {
		const form = document.getElementById('mc-embedded-subscribe-form');
		
		if (!form) {
			return;
		}

		form.addEventListener('submit', function(e) {
			e.preventDefault();
			
			const formData = new FormData(form);
			const inputs = form.querySelectorAll('input[data-placeholder]');
			
			// Clear placeholder values before submission
			inputs.forEach(field => {
				if (field.value === field.getAttribute('data-placeholder')) {
					field.value = '';
				}
			});
			
			// Submit to Mailchimp
			fetch(form.action, {
				method: 'POST',
				body: formData,
				mode: 'no-cors'
			}).then(function() {
				// Redirect after submission
				window.location.href = 'https://marlasimlett.com/thank-you';
			}).catch(function(error) {
				// Even on error, redirect (since no-cors mode doesn't allow reading responses)
				window.location.href = 'https://marlasimlett.com/thank-you';
			});
		});
	}
};

export default InputPlaceholder;
